import { ReachInformationMessage } from '../../../../types/ReachInformationMessage';
import { authorizedAxiosInstance } from '../instances/AuthorizedAxiosInstance';

export async function getReachInformation(vesselId: string): Promise<ReachInformationMessage> {
    const response = await authorizedAxiosInstance.get<ReachInformationMessage>(`/v1/reach-information`, {
        params: {
            vesselId,
        },
    });

    return response.data;
}

export async function getReachInformationForScheduleId(
    vesselId: string,
    scheduleId: string
): Promise<ReachInformationMessage> {
    const response = await authorizedAxiosInstance.get<ReachInformationMessage>(`/v1/reach-information`, {
        params: {
            vesselId,
            scheduleId,
        },
    });

    return response.data;
}
